module.exports = __webpack_public_path__ + "img/senalando-izqgt.2f9cfaa3.png";